import { render, staticRenderFns } from "./monitorCodeBlock.vue?vue&type=template&id=b1894dca&scoped=true&"
import script from "./monitorCodeBlock.vue?vue&type=script&lang=js&"
export * from "./monitorCodeBlock.vue?vue&type=script&lang=js&"
import style0 from "./monitorCodeBlock.vue?vue&type=style&index=0&id=b1894dca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1894dca",
  null
  
)

export default component.exports